import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  selections: [],
  railPosition: '',
  direction: 'clockwise',
  isLoading: true,
  sliders: [],
  isLoggedIn: false,
  showModal: false,
  presetData: [],
  selectedPresetId: '',
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
